addEventListener('click', e => {
  if (e.target.matches('a.sync-member')) {
    e.preventDefault()
    e.target.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'

    fetch(e.target.href, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
    }).finally(() => window.location.reload())
  }
})
